import React from 'react';

import {Box, Stack, Typography, Divider, Button} from 'views/components';
import {Translate} from 'views/module';

const ProfileNotAvailable = () => (
  <Stack width="100%" alignItems="center">
    <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 1,
      m: {xs: 1, md: 2},
    }}>
      <Box
        component="img"
        src="/logo/quilt-icon.png"
        alt="CareQuilt Icon"
        sx={{
          width: {xs: 24, sm: 32, md: 40},
          height: {xs: 24, sm: 32, md: 40},
        }}
      />
      <Typography
        sx={{
          fontWeight: 700,
          color: 'primary.main',
          fontSize: {xs: 24, sm: 32, md: 40},
        }}
      >
        <Translate expression='caregiverProfile.ProfileNotAvailable.CareQuilt'/>
      </Typography>
    </Box>
    <Divider sx={{
      borderColor: 'grey.500',
      borderBottomWidth: 2,
      width: '100%',
    }} />
    <Stack
      spacing={{xs: 3, sm: 4, md: 5, lg: 6}}
      sx={{
        alignItems: 'center',
        maxWidth: {sm: '100%', md: 700, lg: 1000},
        m: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: {xs: 18, sm: 22, md: 26},
          color: 'text.secondary',
          textAlign: 'center',
          mb: 2,
        }}
      >
        <Translate expression='caregiverProfile.ProfileNotAvailable.Title'/>
      </Typography>
      <Typography
        sx={{
          fontSize: {xs: 14, sm: 16, md: 18},
          color: 'text.secondary',
          textAlign: 'center',
          maxWidth: 500,
          mb: 4,
        }}
      >
        <Translate expression="caregiverProfile.ProfileNotAvailable.Description"/>
      </Typography>
      <Button
        variant="contained"
        color="primary"
        href="https://carequilt.ca"
        sx={{mt: 2}}
      >
        <Translate expression="caregiverProfile.ProfileNotAvailable.BackHome"/>
      </Button>
    </Stack>
  </Stack>
);

export default ProfileNotAvailable;
